export const fieldsLists = {
	phone: ["phones", "metadataName"],
	telegram: ["metadataListName", "metadataDate", "metadataName", "metadataTelegramBotName", "metadataTelegramUserId", "metadataTelegramChatId"],
};

export const mapCallStatus = ({
	status,
}: {
	status: "PENDING" | "IN_PROGRESS" | "COMPLETED" | "FAILED";
}): { color: "green" | "orange" | "red" | "gray"; titleStatus: string } => {
	let color: "green" | "orange" | "red" | "gray" = "gray";
	let titleStatus = "title_completed";
	if (!status) return { color, titleStatus };

	switch (status) {
		case "IN_PROGRESS":
			color = "green";
			break;
		case "COMPLETED":
			color = "gray";
			break;
		case "PENDING":
			color = "orange";
			break;
		case "FAILED":
			color = "red";
			break;
		default:
			color = "red";
	}

	switch (status) {
		case "IN_PROGRESS":
			titleStatus = "title_inProgress";
			break;
		case "COMPLETED":
			titleStatus = "title_completed";
			break;
		case "PENDING":
			titleStatus = "title_pending";
			break;
		case "FAILED":
			titleStatus = "title_failed";
			break;
		default:
			titleStatus = "title_failed";
	}

	return { color, titleStatus };
};

export const getNowTime = () => {
	const now = new Date();

	const year = now.getFullYear();
	const month = String(now.getMonth() + 1).padStart(2, "0");
	const day = String(now.getDate()).padStart(2, "0");
	const hours = String(now.getHours()).padStart(2, "0");
	const minutes = String(now.getMinutes()).padStart(2, "0");

	return `${year}-${month}-${day} ${hours}:${minutes}`;
};

export const getOneMonthAgo = () => {
	const now = new Date();
	const oneMonthAgo = new Date();
	oneMonthAgo.setMonth(now.getMonth() - 1);

	const year = oneMonthAgo.getFullYear();
	const month = String(oneMonthAgo.getMonth() + 1).padStart(2, "0");
	const day = String(oneMonthAgo.getDate()).padStart(2, "0");
	const hours = String(oneMonthAgo.getHours()).padStart(2, "0");
	const minutes = String(oneMonthAgo.getMinutes()).padStart(2, "0");

	return `${year}-${month}-${day}T${hours}:${minutes}`;
};
